import './App.css';
import { BrowserRouter as BRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useRef } from 'react';
import Calendar from './admin_components/Calendar';
import './css/all.css'
import './css/font.css'
import Login from './components/Login';
import GlobalContext, { defaultValues } from './GlobalContext';
import { useImmer } from 'use-immer';
import Customers from './admin_components/Customers';
import Alert from './components/Alert';
import LoadingScreen from './components/LoadingScreen';
import ServiceContext, { defaultServiceValues } from './ServiceContext';
import Statistics from './admin_components/Statistics';
import TextContext, { defaultTextValues } from './TextContext';
import GapiLandingPage from './components/GapiLandingPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdminLogin from './components/AdminLogin';
import CalendarContext, { defaultCalendarValues } from './CalendarContext.js';
import CustomerRequestForm from './components/CustomerRequestForm.js';
import DataLoader from './admin_components/DataLoader.js';



window.console.debug = (...args) => {
  //cond debug
  console.log(args)
}

const isInteger = (number) => {
  if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
  return !(number - parseInt(number));
}

const isFloat = (number) => {
  if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
  return number - parseInt(number) ? true : false;
}

const standardFetch = window.fetch


const FRONTEND_VERSION='1.2.3'
const BACKEND_VERSION='1.1'


const App = () => {

  const [globals, setGlobals] = useImmer(defaultValues)
  const [service, setService] = useImmer(defaultServiceValues)
  const [texts, setTexts] = useImmer(defaultTextValues)
  const [calendar, setCalendar] = useImmer(defaultCalendarValues)
  //const [isLoading, setIsLoading]=useState(false)
  const isLoadingRef = useRef(0)

  const checkMobile = () => {
    const heigth = window.screen.height
    const width = window.screen.width
    console.log('h: ', heigth, ' w: ', width)
    const factor = parseFloat(width) / parseFloat(heigth)

    // const segments = new URL(href).pathname.split('/');
    // const last = segments.pop() || segments.pop(); // Handle potential trailing slash
    if (factor < 0.725 && window.location.pathname.split("/").pop()!='customer_request_form') {
      window.location.href = "https://nacplan.ch/index.php/home/app/";
    }
  }

  window.fetch = async (input, init = undefined, keepLoad = false) => {
    // isLoadingRef.current=isLoadingRef.current+1
    // setIsLoading(true)
    const url=new URL(input)
    url.searchParams.set('backend_version', BACKEND_VERSION)
    const resp = await standardFetch(url.toString(), init)
    // isLoadingRef.current=isLoadingRef.current-1
    // if(isLoadingRef.current==0&&!keepLoad){
    //   setIsLoading(false)
    // }
    return resp
  }

  useEffect(() => {
    checkMobile()
  }, [])

  return (
    <GlobalContext.Provider value={{ set: setGlobals, get: globals }} >
      <ServiceContext.Provider value={{ set: setService, get: service }} >
        <TextContext.Provider value={{ set: setTexts, get: texts.getText, value: texts }}>
          <CalendarContext.Provider value={{ set: setCalendar, get: calendar }} >
            <BRouter>
              <Routes>
                <Route exact path='/' element={<Login />} />
                <Route exact path='/calendar' element={<Calendar />} />
                <Route exact path='/customers' element={<Customers />} />
                <Route exact path='/statistics' element={<Statistics />} />
                <Route exact path='/gapiland' element={<GapiLandingPage />} />
                <Route exact path='/privacy_policy' element={<PrivacyPolicy />} />
                <Route exact path='/admin_console' element={<AdminLogin />} />
                <Route exact path='/customer_request_form' element={<CustomerRequestForm />} />
              </Routes>
            <DataLoader />
            </BRouter>
            <Alert />
            <span className='version-box' >
              Ver. {FRONTEND_VERSION}
            </span>
            {service.Load.isLoading ? (<LoadingScreen />) : (<></>)}
          </CalendarContext.Provider>
        </TextContext.Provider>
      </ServiceContext.Provider>
    </GlobalContext.Provider>
  )
}


export default App;
